<script setup>
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { AddressCategories } from './enum';
import AddressDetailsHeader from './AddressDetailsHeader.vue';
import AddressDetailsFormInformations from './AddressDetailsForm/AddressDetailsFormInformations.vue';
import AddressDetailsFormServices from './AddressDetailsForm/AddressDetailsFormServices.vue';
import SellerBrandFormDescription from './SellerBrandForm/SellerBrandFormDescription.vue';
import SellerBrandPhotoView from './SellerBrandPhotos/SellerBrandPhotoView.vue';

defineProps({
  address: {
    type: Object,
    required: true,
  },
});
const router = useRouter();
const route = useRoute();
const activeTab = ref(AddressCategories.INFORMATIONS);

const tabs = new Map([
  [ AddressCategories.INFORMATIONS, AddressDetailsFormInformations ],
  [ AddressCategories.SERVICES, AddressDetailsFormServices ],
  [ AddressCategories.PHOTOS, SellerBrandPhotoView ],
  [ AddressCategories.DESCRIPTION, SellerBrandFormDescription ],
]);

const tabChange = (newTab) => {
  activeTab.value = newTab;
};

onMounted(async () => {
  await router.isReady();
  if (route.query.tab && Object.values(AddressCategories).includes(route.query.tab)) {
    activeTab.value = route.query.tab;
  }
});
</script>

<template>
  <div class="details-content__tabs">
    <AddressDetailsHeader
      :active-tab="activeTab"
      :address="address"
      @tab-change="tabChange"
    />
    <component
      :is="tabs.get(activeTab)"
      :address="address"
    />
  </div>
</template>
